// extracted by mini-css-extract-plugin
export default {"checkin_form":"CheckIn_checkin_form__5A19Q"};